export default __webpack_public_path__ + "img/membership_card_lite-d0e4a52976826301395789767b855eea.png";